import { getPortCoKeys } from './getPortCoKeys';
import { TableKeys, QuarterKey, RowWithDate } from '../types';
import { roundToDecimal } from './helpers';
import { MIL_KEYS, PERC_KEYS, THOUSANDS_KEYS } from './constants';

export const mapOverrides = (
  data: Record<string, Partial<Record<string, string | null>>>,
  quarterData: Record<QuarterKey, RowWithDate>
): RowWithDate[] => {
  const transformedData = transformOverrides(data, quarterData);

  return transformedData.map(d => {
    const result: RowWithDate = {
      QUARTER: d.QUARTER,
      PERIOD_END: d.PERIOD_END
    };

    for (const key in d) {
      if (key !== 'PERIOD_END' && key !== 'QUARTER') {
        const newKey = getPortCoKeys[key as TableKeys];

        result[newKey] = !d[key]
          ? 0
          : MIL_KEYS.includes(newKey)
          ? Number(d[key]) * 1000000
          : THOUSANDS_KEYS.includes(newKey)
          ? Number(d[key]) * 1000
          : PERC_KEYS.includes(newKey)
          ? Number(roundToDecimal(Number(d[key]) / 100, 5))
          : Number(d[key]);
      }
    }

    return result;
  });
};

const transformOverrides = (
  input: Record<string, Partial<Record<string, string | null>>>,
  quarterData: Record<QuarterKey, RowWithDate>
): RowWithDate[] => {
  const periodMap: Record<string, RowWithDate> = {};

  for (const metricKey in input) {
    const periods = input[metricKey] || {};

    for (const quarterKey in periods) {
      const rawValue = periods[quarterKey];
      if (rawValue == null) continue;

      const match = quarterKey.match(/^q([1-4])_(\d{4})$/);
      if (!match) continue;

      const qData = quarterData[quarterKey as QuarterKey];
      const qKey = qData.QUARTER;

      if (!periodMap[qKey]) {
        periodMap[qKey] = { ...qData };
      }

      periodMap[qKey][metricKey] = parseFloat(rawValue?.replace(/,/g, ''));
    }
  }

  return Object.values(periodMap);
};
